import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { string_required } from '../../../validation/validationSchema';
import Select from 'react-select';
import { useMutation } from 'react-query';
import { uploadSMSRates } from '../../../api-services';
import swal from 'sweetalert';

const initialState = {
  file: '',
  provider: [],
  currency: '',
  margin: '',
};

const SMSRateUpload = ({ setOpenModal, openModal, AllProvidersSMS }) => {
  const [initialValues, setInitialValues] = useState(initialState);

  const { mutateAsync, isLoading } = useMutation(
    'uploadCallRates',
    (payload) => uploadSMSRates(payload),
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          // queryClient.invalidateQueries('numberListing');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const validationSchema = Yup.object().shape({
    file: Yup.mixed().required('File is required'),
    provider: Yup.array().min(1).required('Provider is required'),
    currency: string_required,
    margin: Yup.number().required('Margin is required'),
  });

  const handleSubmitForm = async (values) => {
    const { file, provider, currency, margin } = values;
    const formData = new FormData();
    formData.append('csv_file', file);
    formData.append('currency', currency);
    formData.append('margin', margin);
    formData.append(
      'provider',
      JSON.stringify(provider.map((val) => val?.value)),
    );
    await mutateAsync(formData);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handleClose = () => {
    setOpenModal(false);
    formik.resetForm();
  };

  return (
    <Modal
      size="md"
      centered
      show={openModal}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            Upload Rates
          </h5>
        </div>

        <div className="modal-body">
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="file"
                className="form-control"
                placeholder="Select file..."
                name="file"
                accept=".csv,.xlsx"
                onChange={(event) => {
                  formik.setFieldValue('file', event.currentTarget.files[0]);
                }}
              />

              {formik.touched.file && formik.errors.file ? (
                <div className="error_required">{formik.errors.file}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100 custom_input">
              <Select
                placeholder="Select provider..."
                options={
                  AllProvidersSMS &&
                  AllProvidersSMS.length > 0 &&
                  AllProvidersSMS.map(({ providerID, name }, index) => {
                    return { value: providerID, label: name };
                  })
                }
                isMulti={true}
                name="lcr"
                onChange={(val) => formik.setFieldValue('provider', val, false)}
              />
              {formik.touched.provider && formik.errors.provider ? (
                <div className="error_required">{formik.errors.provider}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <select
                className="form-control"
                name="currency"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.currency}
              >
                <option value="">Please select currency</option>
                <option value="EURO" key="1">
                  EURO
                </option>
                <option value="XOF" key="2">
                  XOF
                </option>
                <option value="USD" key="2">
                  USD
                </option>
                <option value="GBP" key="2">
                  GBP
                </option>
              </select>
              {formik.touched.currency && formik.errors.currency ? (
                <div className="error_required">{formik.errors.currency}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap position-relative">
            <div className="w-100 ">
              <input
                type="number"
                step="any"
                className="form-control"
                placeholder="Margin"
                name="margin"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.margin}
              />
              <span className="input-icon">%</span>
              {formik.touched.margin && formik.errors.margin ? (
                <div className="error_required">{formik.errors.margin}</div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            disabled={isLoading}
            onClick={() => handleClose()}
          >
            Close
          </button>

          <button
            type="submit"
            className="btn btn-dark-blue"
            disabled={isLoading}
          >
            {isLoading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default SMSRateUpload;
